import { Component, OnInit, NgModule, Input, Output, EventEmitter } from '@angular/core';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';
import { Person } from '../../../models/person';
import { Usef_person } from '../../../models/usef/usef_person';
import * as dayjs from 'dayjs';

@Component({
  standalone: false,
  selector: 'edit-person',
  inputs: ['person'],
  templateUrl: './edit-person.component.html',
styleUrls:  ['./edit-person.component.css']
})

export class EditPersonComponent extends SmsAbstractAppPage implements OnInit {
  @Input() person: Person;
  @Input() usef_person: Usef_person;
  @Input() hide_save_button: boolean = false;
  @Output() person_saved$: EventEmitter<Person> = new EventEmitter<Person>();
  @Input() save_in_progress: boolean;

  useGoogleAddress: boolean = false;

  updateAddressFromAutocomplete(addr: any) {
    this.person.address_1 = `${addr.street_number || ''} ${addr.route || ''}`.trim();
    this.person.city = addr.city || '';
    this.person.state = addr.state || '';
    this.person.postal_code = `${addr.zip || ''}${addr.zipPlus4 ? '-' + addr.zipPlus4 : ''}`.trim();
    this.person.country = addr.countryCode || '';
    this.useGoogleAddress = true;
  }

  handleSelectCountry(country: string) {
    this.person.country = country;
  }

  constructor() {
    super();
  }

  ngOnInit() {
  }

  handleSavePerson(person: Person){
    this.person_saved$.emit(person);
  }

  handleSelectState(state: string){
    this.person.state = state;
  }

  handleClickUseFed(){
    if(this.person.use_usef_personal_details){
      this.person.birth_date = this.usef_person.date_of_birth;
      this.person.address_1 = this.usef_person.address1;
      this.person.address_2 = this.usef_person.address2;
      this.person.email = this.usef_person.email_address;
      if(this.usef_person.phone_numbers.length > 0){
        this.person.phone = this.usef_person.phone_numbers[0].number;
      }
    } else {
      this.person.birth_date = null;
      this.person.address_1 = '';
      this.person.address_2 = '';
      this.person.phone = '';
      this.person.email = '';
    }
  }


}
